export default __webpack_public_path__ + "static/6854-dc47fb6ab5cf3a3bfb0776fda34b31a4.jpg";